import type { QuickSearchCategoryView } from '@/components/QuickSearch/quickSearchRoutes'
import { VpButton, VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

interface SeeAllButtonProps {
  category: QuickSearchCategoryView
  total: number
  displayed: number
  onSeeAll: (category: QuickSearchCategoryView) => void
  ref?: React.Ref<HTMLButtonElement>
}

const SEE_ALL_TRANSLATION_KEYS: Record<QuickSearchCategoryView, string> = {
  subdepartments: 'quick-search.see-all-subdepartments',
  families: 'quick-search.see-all-families',
  supermodels: 'quick-search.see-all-supermodels',
  models: 'quick-search.see-all-models',
}

export function SeeAllButton({ category, total, displayed, onSeeAll, ref }: Readonly<SeeAllButtonProps>) {
  const { t } = useTranslation()

  if (total <= displayed) {
    return null
  }

  return (
    <VpButton
      type="button"
      variant="secondary"
      size="small"
      onClick={() => onSeeAll(category)}
      startSlot={<VpIcon name="search" />}
      ref={ref}
    >
      {t(SEE_ALL_TRANSLATION_KEYS[category])}
    </VpButton>
  )
}
